import Image, { StaticImageData } from "next/image"

type Props = {
  img: string | StaticImageData
  title: string
  description: string
}

const Card = ({ img, title, description }: Props) => {
  return (
    <div className='col-span-12 rounded-md bg-white px-6 pt-2 cardShadow md:col-span-6 lg:col-span-3'>
      <div className='flex flex-col items-center'>
        <Image alt="Card image" src={img} className='w-20 pb-4 pt-7' />
        <h3 className='mb-4 text-xl font-semibold text-primary transition-all hover:text-secondary lg:w-36'>
          {title}
        </h3>
        <p className='pb-10 lg:w-36'>{description}</p>
      </div>
    </div>
  )
}

export default Card
